export const API_CONFIG = {
  REQUEST_TIMEOUT_MS: 30000,
} as const;

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'google_access_token',
  ID_TOKEN: 'google_id_token',
  USER_NAME: 'google_user_name',
  USER_EMAIL: 'google_user_email',
  USER_PICTURE: 'google_user_picture',
  CODE_VERIFIER: 'oauth_code_verifier',
  OAUTH_STATE: 'oauth_state',
  SESSION_START: 'session_start',
} as const;

export const SESSION_CONFIG = {
  MAX_DURATION_MS: 24 * 60 * 60 * 1000, // 24 hours
  WARNING_THRESHOLD_MS: 30 * 60 * 1000, // 30 minutes
  CHECK_INTERVAL_MS: 60 * 1000, // 1 minute
} as const;

export const ALLOWED_GOOGLE_DOMAIN = 'encorestateplans.com';

// Record Type IDs
export const RECORD_TYPES = {
  TRANSACTION: '012Vs000004gYUQIA2',
  SALES_OPPORTUNITY: '012Vs0000044mTZIAY',
} as const;

// SOQL WHERE-clause fragments to exclude inactive records
export const EXCLUDE_DEACTIVATED_ACCOUNTS = ' AND Encore_Account_Deactivated__c != true';
export const EXCLUDE_DEACTIVATED_ACCOUNTS_REL = ' AND Account.Encore_Account_Deactivated__c != true';
export const EXCLUDE_DEMO_DEACTIVATED_USERS = ' AND Is_Demo__c != true AND Encore_User_Deactivated__c != true';

// Firm deactivation exclusion. The deactivation flag lives ONLY on Account (not on
// Encore_Firm__c in this org), but every Encore_Firm__c row has Account__c populated,
// so it's reachable via Account__r. Direct form is for `FROM Encore_Firm__c` queries;
// the _REL form for Opportunity queries that traverse the Encore_Firm__c lookup (Orders).
export const EXCLUDE_DEACTIVATED_FIRMS = ' AND Account__r.Encore_Account_Deactivated__c != true';
export const EXCLUDE_DEACTIVATED_FIRMS_REL = ' AND Encore_Firm__r.Account__r.Encore_Account_Deactivated__c != true';

export const SF_BASE = 'https://encorestateplans.my.salesforce.com';

export const HUBSPOT_API = {
  PROXY_BASE: '/api/hubspot',
  CACHE_TTL_MS: 15 * 60 * 1000, // 15 min
} as const;

